import React from "react";
import './Header.css';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="header">
      <h1 className="site-title">Matthew Leopold</h1>
      <nav>
        <ul className="header-links">
          <li>
            <Link to="/">Projects</Link>
          </li>
          <li>
            <Link to="/resume">Resume</Link>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/matthew-leopold-b90686227/">LinkedIn</a>
          </li>
          <li>
            <a href="https://github.com/H-137">GitHub</a>
          </li>
        </ul>
      </nav>
    </header>
  );
}